// src/components/AdminRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminRoute({ children }) {
  const { user, role, loading } = useAuth();

  // Show loading state while authentication is being checked
  if (loading) return <p>Loading...</p>;

  // If no user or role is not admin → redirect out
  if (!user || role !== "admin") {
    return <Navigate to="/" replace />;
  }

  // User is admin → allow access
  return children;
}
